<template>
  <div class="container">
    <app-header title="权益商品"/>
    <div class="headerequity">
      <div class="title">会员升级·权益商品</div>
      <div class="welfare">购物专享成长福利，专属优惠送不停</div>
      <div class="goumai">
        <img src="@/assets/crown.png" height="14" width="14" style="margin-left: 15px;padding-top: 7px"/>
        <div style="margin-left: 15px">购买以下商品立即成为分销会员</div>
      </div>
    </div>

    <div class="recommend-content">
      <van-row gutter="10">
        <van-col span="12" v-for="i in 4" :key="i">
          <div class="item">
            <img src="@/assets/goods03.png" alt="goods03" width="170">
            <div class="content">
              <div class="name">电子产品-手动、自动两用，明星同款</div>
              <div class="footer">
                <span class="price">￥388</span>
              </div>
              <div class="pay">
                <img src="@/assets/crown.png" height="14" width="14" style="margin-left: 15px;padding-top: 7px"/>
                <div style="margin-left: 15px">立即购买</div>
              </div>
            </div>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Commodity',
  data() {
    return {
      value: ''
    }
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
  .container{
    .headerequity{
      width:100%;
      height:121px;
      background:rgba(66,64,77,1);
      opacity:1;
      .title{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:800;
        line-height:22px;
        color:rgba(255,255,255,1);
        opacity:1;
        text-align: center;
        padding-top: 18px;
      }
      .welfare{
        text-align: center;
        font-size:12px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:17px;
        color:rgba(245,193,100,1);
        letter-spacing: 3px;
        opacity:1;
        margin-top: 4px;
      }
      .goumai{
        display: flex;
        width:279px;
        height:30px;
        background:rgba(239,182,93,1);
        opacity:1;
        border-radius:15px;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:bold;
        line-height:30px;
        color:rgba(126,75,44,1);
        margin-top: 19px;
        margin-left: 15%;
      }
    }
    .recommend-content{
      padding: 10px 12px;
      background: #ffffff;
      .item{
        border:1px solid rgba(243,243,243,1);
        .name{
          height:38px;
          font-size:14px;
          font-weight:bold;
          line-height:17px;
          color:rgba(51,51,51,1);
          opacity:1;
        }
        .footer{
          display: flex;
          justify-content: space-between;
          .price{
            height:30px;
            font-size:16px;
            font-weight:bold;
            line-height:30px;
            color:rgba(254,0,59,1);
          }
        }
        .pay{
          display: flex;
          background: red;
          height: 30px;
          line-height: 30px;
          color: #ffffff;
          width: 80%;
          margin-left: 10%;
          margin-bottom: 10px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/vip/commodity.vue